import * as _ from 'lodash';

export function fiIntersection<T>(arrayA: T[], arrayB: T[]): T[] {
    return _.intersection(arrayA, arrayB);
}
